import React, { useEffect,  useRef, useState } from "react";

import { Row, Col, Offcanvas, Button } from "react-bootstrap";
import Cookies from "js-cookie";
import FASFilterBox from "../../../../../components/FilterBox/FASFilter/FASFilter";
import { format } from "date-fns";


import { FiMenu } from "react-icons/fi";
import { MdOutlineSystemUpdateAlt } from "react-icons/md";
import FASTable from "../../../../../components/Tables/FASTable";
import { useDispatch, useSelector } from "react-redux";
import {
  PurchaseAcList,
  PurchaseAnalysis,
  PurchaseBookList,
} from "../../../../../Redux/Slice/Fas/DayBook Analysis/Purchase/PurchaseSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import { useTheme } from "../../../../../Themecontext/Themecontext";
import Calendar from "react-calendar";
import FASCalender from "../../../../../components/Calendar/FASCalender";

export const MonthWisePartyWisePurchase = () => {
  const dispatch = useDispatch();

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { PurchaseBookListdata, PurchaseAcListtdata, PurchaseAnalysisdata } =
    useSelector((state) => state.PurchaseSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const YearId = Cookies.get("FinancialYear");
  const FinancialYear = Cookies.get("FinancialYear");

  const [isFilterLoading, setIsFilterLoading] = useState(false);

  const [filters, setFilters] = useState({
    purchaseBook: [],
    account: [],
  });
  const [search, setSearch] = useState({
    purchaseBook: "",
    account: "",
  });
  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);
  const [activeTable, setActiveTable] = useState("MonthWise");
  const [showFilter, setShowFilter] = useState(false);
  const handleClose = () => setShowFilter(false);
  const handleShow = () => setShowFilter(true);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showDateFilter, setShowDateFilter] = useState(true);

  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return null;
    return format(new Date(date), "yyyy-MM-dd");
  };

  useEffect(() => {
    dispatch(PurchaseBookList({ Firm, Year: YearId }));
    dispatch(PurchaseAcList({ Firm, Year: YearId }));
  }, [dispatch, Firm, YearId]);

  useEffect(() => {
    if (!startDate || !endDate) return;

    dispatch(
      PurchaseAnalysis({
        Firm,
        Year: YearId,
        BookIDs: "",
        selectSalepartyIds: "",
        selectestartdate: safeFormat(startDate),
        selectenddate: safeFormat(endDate),
      }),
    );
  }, [startDate, endDate]);

  const purchaseBookList =
    PurchaseBookListdata?.Dtl?.map((item) => ({
      label: item?.BookName,
      value: item?.BookId,
    })) || [];
  const purchaseAccountList =
    PurchaseAcListtdata?.Dtl?.map((item) => ({
      label: item?.AcName,
      value: item?.AcID,
    })) || [];

  const monthwisepurchaseRows = () => {
    return (
      PurchaseAnalysisdata?.MonthDtl?.map((item, index) => ({
        srNumber: index + 1,
        ...item,
      })) || []
    );
  };

  const monthwisepurchaseColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Month Name",
      key: "MonthName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "PCS", key: "Pcs", align: "right", format: "true" },
    { label: "Meter", key: "Meter", align: "right", format: "true" },
    { label: "Amount", key: "Amount", align: "right", format: "true" },
    { label: "Net Amount", key: "NetAmount", align: "right", format: "true" },
  ];

  // Data for the table PartywisepurchaseRows
  const PartywisepurchaseRows = () => {
    return (
      PurchaseAnalysisdata?.PartyDtl?.map((item, index) => ({
        // srNumber: index + 1,
        ...item,
      })) || []
    );
  };

  const PartywisepurchaseColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Party Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "PCS", key: "Pcs", align: "right", format: "true" },
    { label: "Meter", key: "Meter", align: "right", format: "true" },
    { label: "Amount", key: "Amount", align: "right", format: "true" },
    { label: "Net Amount", key: "NetAmount", align: "right", format: "true" },
  ];

  const MonthwisepurchasechartRows = () => {
    return (
      PurchaseAnalysisdata?.Dtl?.map((item, index) => ({
        chart: true,
        // srNumber: index + 1,
        AcName: item.AcName,
        Total: item.Total,
        AprAmt: item.AprAmt,
        MayAmt: item.MayAmt,
        JunAmt: item.JunAmt,
        JulAmt: item.JulAmt,
        AugAmt: item.AugAmt,
        SepAmt: item.SepAmt,
        OctAmt: item.OctAmt,
        NovAmt: item.NovAmt,
        DecAmt: item.DecAmt,
        JanAmt: item.JanAmt,
        FebAmt: item.FebAmt,
        MarAmt: item.MarAmt,
      })) || []
    );
  };

  const MonthwisepurchasechartColumns = [
    { label: "Chart", key: "charts", align: "center" },
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Party Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Total Amount", key: "Total", align: "right", format: "true" },
    { label: "Apr", key: "AprAmt", align: "right", format: "true" },
    { label: "May", key: "MayAmt", align: "right", format: "true" },
    { label: "Jun", key: "JunAmt", align: "right", format: "true" },
    { label: "Jul", key: "JulAmt", align: "right", format: "true" },
    { label: "Aug", key: "AugAmt", align: "right", format: "true" },
    { label: "Sep", key: "SepAmt", align: "right", format: "true" },
    { label: "Oct", key: "OctAmt", align: "right", format: "true" },
    { label: "Nov", key: "NovAmt", align: "right", format: "true" },
    { label: "Dec", key: "DecAmt", align: "right", format: "true" },
    { label: "Jan", key: "JanAmt", align: "right", format: "true" },
    { label: "Feb", key: "FebAmt", align: "right", format: "true" },
    { label: "Mar", key: "MarAmt", align: "right", format: "true" },
  ];
  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };

  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const toggleItem = (type, item) => {
    setFilters((prev) => {
      const selected = prev[type];

      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };

  const applyFilter = async () => {
    setIsFilterLoading(true);

    const payload = {
      Firm,
      Year: YearId,
      BookIDs: filters.purchaseBook.join(","),
      selectSalepartyIds: filters.account.join(","),
      selectestartdate: safeFormat(startDate),
      selectenddate: safeFormat(endDate),
    };

    try {
      await dispatch(PurchaseAnalysis(payload));
    } finally {
      setIsFilterLoading(false);
    }
  };

  const isLoading =
    isFilterLoading ||
    !PurchaseAnalysisdata ||
    !PurchaseAcListtdata ||
    !PurchaseBookListdata ||
    isFilterLoading;

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div
      style={{
        padding: "16px",
        background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
        minHeight: "100vh",
      }}
    >
      {/* MOBILE BUTTON */}
      <div className="d-lg-none d-flex justify-content-end mb-3">
        <Button
          onClick={handleShow}
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour8,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour3,
            border: "none",
            borderRadius: "10px",
            padding: "8px 12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
          }}
        >
          <FiMenu size={22} />
        </Button>
      </div>

      {/* OFFCANVAS */}
      <Offcanvas
        show={showFilter}
        onHide={handleClose}
        placement="start"
        style={{
          background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
        }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title
            style={{ color: isdark === "light" ? "#000" : "#fff" }}
          >
            Filters
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "16px" }}
          >
            {showDateFilter && (
              <div>
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour10,
                    padding: "13px 20px",
                    borderRadius: "10px 10px 0px 0px",
                  }}
                >
                  <h3
                    style={{
                      fontWeight: "700",
                      fontSize: "18px",
                      margin: 0,
                      color:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour1,
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    {" "}
                    Date Range
                  </h3>
                </div>
                <div
                  style={{
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour10}`,
                    padding: "15px",
                    marginBottom: "15px",
                    background:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour1,
                    borderRadius: "0px 0px 10px 10px",
                  }}
                >
                  <div
                    onClick={() => setShowDatePicker(true)}
                    style={{
                      marginTop: "8px",
                      padding: "10px",
                      border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour10}`,
                      borderRadius: "8px",
                      cursor: "pointer",
                      color:
                        isdark === "light" ? "#000" : iscolourDark?.Colour11,
                      textAlign: "center",
                    }}
                  >
                    {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                      ? `${format(dateRange[0].startDate, "dd-MM-yyyy")} - ${format(dateRange[0].endDate, "dd-MM-yyyy")}`
                      : "Select Date Range"}
                  </div>
                </div>
              </div>
            )}
            <FASFilterBox
              title="Purchase Books"
              items={purchaseBookList}
              search={search.purchaseBook}
              setSearch={(val) => handleSearch("purchaseBook", val)}
              selectedItems={filters.purchaseBook}
              toggleItem={(item) => toggleItem("purchaseBook", item)}
              selectAll={() => selectAll("purchaseBook", purchaseBookList)}
            />

            <FASFilterBox
              title="Account Name"
              items={purchaseAccountList}
              search={search.account}
              setSearch={(val) => handleSearch("account", val)}
              selectedItems={filters.account}
              toggleItem={(item) => toggleItem("account", item)}
              selectAll={() => selectAll("account", purchaseAccountList)}
            />
            <Button
              onClick={() => {
                applyFilter();
                handleClose();
              }}
              style={{
                width: "100%",
                height: "44px",
                borderRadius: "10px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour5
                    : iscolourDark?.Colour10,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour3,
                border: "none",
                fontWeight: "600",
              }}
            >
              Apply Filters
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Row className="g-4 align-items-start">
        {/* DESKTOP FILTER */}
        <Col xl={3} lg={4} className="d-none d-lg-block">
          <div
            style={{ display: "flex", flexDirection: "column", gap: "16px" }}
          >
            {showDateFilter && (
              <div>
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour10,
                    padding: "13px 20px",
                    borderRadius: "10px 10px 0px 0px",
                  }}
                >
                  <h3
                    style={{
                      fontWeight: "700",
                      fontSize: "18px",
                      margin: 0,
                      color:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour1,
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    {" "}
                    Date Range
                  </h3>
                </div>
                <div
                  style={{
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour10}`,
                    padding: "15px",
                    background:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour1,
                    borderRadius: "0px 0px 10px 10px",
                  }}
                >
                  <div
                    onClick={() => setShowDatePicker(true)}
                    style={{
                      marginTop: "8px",
                      padding: "10px",
                      border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour10}`,
                      borderRadius: "8px",
                      cursor: "pointer",
                      color:
                        isdark === "light" ? "#000" : iscolourDark?.Colour11,
                      textAlign: "center",
                    }}
                  >
                    {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                      ? `${format(dateRange[0].startDate, "dd-MM-yyyy")} - ${format(dateRange[0].endDate, "dd-MM-yyyy")}`
                      : "Select Date Range"}
                  </div>
                </div>
              </div>
            )}
            <FASFilterBox
              title="Purchase Books"
              items={purchaseBookList}
              search={search.purchaseBook}
              setSearch={(val) => handleSearch("purchaseBook", val)}
              selectedItems={filters.purchaseBook}
              toggleItem={(item) => toggleItem("purchaseBook", item)}
              selectAll={() => selectAll("purchaseBook", purchaseBookList)}
            />

            <FASFilterBox
              title="Account Name"
              items={purchaseAccountList}
              search={search.account}
              setSearch={(val) => handleSearch("account", val)}
              selectedItems={filters.account}
              toggleItem={(item) => toggleItem("account", item)}
              selectAll={() => selectAll("account", purchaseAccountList)}
            />
            <Button
              onClick={applyFilter}
              style={{
                width: "100%",
                height: "44px",
                borderRadius: "10px",
                marginTop: "10px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour5
                    : iscolourDark?.Colour10,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour3,
                border: "none",
                fontWeight: "600",
              }}
            >
              Apply Filters
            </Button>
          </div>
        </Col>

        {/* RIGHT SIDE */}
        <Col xl={9} lg={8} md={12}>
          <Row className="g-3">
            <div style={{ marginTop: "20px" }}>
              <div
                style={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour12
                      : iscolourDark?.Colour8,
                }}
              >
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour4,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour11,
                    borderTopLeftRadius: "12px",
                    borderTopRightRadius: "12px",
                    padding: "12px",
                    margin: 0,
                  }}
                >
                  <h5
                    style={{
                      fontSize: "18px",
                      margin: 0,
                      letterSpacing: "1px",
                      fontWeight: "600",
                    }}
                  >
                    MONTHWISE PARTYWISE PURCHASE
                  </h5>
                </div>

                <FASTable
                  data={MonthwisepurchasechartRows()}
                  columns={MonthwisepurchasechartColumns}
                />
              </div>
            </div>
            <Col xs={12}>
              {/* ✅ BUTTONS */}
              <div
                style={{ display: "flex", gap: "12px", marginBottom: "12px" }}
              >
                {["MonthWise", "PartyWise"].map((btn) => (
                  <button
                    key={btn}
                    onClick={() => setActiveTable(btn)}
                    style={{
                      flex: 1,
                      height: "50px",
                      borderRadius: "12px",
                      cursor: "pointer",
                      fontWeight: "600",
                      border: `2px solid ${
                        isdark === "light"
                          ? iscolour?.Colour5
                          : iscolourDark?.Colour10
                      }`,
                      background:
                        activeTable === btn
                          ? isdark === "light"
                            ? iscolour?.Colour5
                            : iscolourDark?.Colour10
                          : isdark === "light"
                            ? iscolour?.Colour1
                            : iscolourDark?.Colour4,
                      color:
                        activeTable === btn
                          ? isdark === "light"
                            ? iscolour?.Colour1
                            : iscolourDark?.Colour1
                          : isdark === "light"
                            ? iscolour?.Colour12
                            : iscolourDark?.Colour11,
                    }}
                  >
                    {btn}
                  </button>
                ))}
              </div>

              {/* ✅ HEADING */}
              <div
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour5
                      : iscolourDark?.Colour4,
                  color:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour11,
                  padding: "14px",
                  borderTopLeftRadius: "12px",
                  borderTopRightRadius: "12px",
                }}
              >
                <h5
                  style={{
                    fontSize: "18px",
                    margin: 0,
                    letterSpacing: "1px",
                    fontWeight: "600",
                  }}
                >
                  {activeTable === "MonthWise"
                    ? "MONTHWISE PURCHASE"
                    : "PARTYWISE PURCHASE"}
                </h5>
              </div>

              {/* ✅ TABLE SWITCH */}
              <div
                style={{
                  borderBottomLeftRadius: "12px",
                  borderBottomRightRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
                }}
              >
                <FASTable
                  data={
                    activeTable === "MonthWise"
                      ? monthwisepurchaseRows()
                      : PartywisepurchaseRows()
                  }
                  columns={
                    activeTable === "MonthWise"
                      ? monthwisepurchaseColumns
                      : PartywisepurchaseColumns
                  }
                />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      {showDatePicker && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
          onClick={() => setShowDatePicker(false)}
        >
          <FASCalender
            isdark={isdark}
            iscolour={iscolour}
            iscolourDark={iscolourDark}
          />
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour3,

              borderRadius: "20px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Calendar
              className="custom-calendar"
              selectRange={true}
              onChange={(value) => {
                if (Array.isArray(value)) {
                  setDateRange([
                    {
                      startDate: value[0],
                      endDate: value[1],
                      key: "selection",
                    },
                  ]);
                }
              }}
              value={
                dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? [dateRange[0].startDate, dateRange[0].endDate]
                  : null
              }
            />

            <div
              className="date-picker-footer"
              style={{
                textAlign: "center",
                marginTop: "15px",
                padding: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour3
                    : iscolourDark?.Colour3,
                borderRadius: "0 0 20px 20px",
              }}
            >
              <button
                onClick={() => setShowDatePicker(false)}
                style={{
                  padding: "10px",
                  borderRadius: "12px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "700",
                  color: "#fff",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour12
                      : iscolourDark?.Colour7,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                  transition: "0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = "0.85";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = "1";
                  e.target.style.transform = "scale(1)";
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
